import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { Grid, Typography } from "@mui/material";
import { isDayjs } from "dayjs";
import { FC } from "react";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { useEnum } from "@/api/services/global/enum";
import { findLabelByValue } from "@/utils/object";

type TLearnerExamInfoDetailProps = {
  data?: Partial<TLearnerForm>;
};

export const LearnerExamInfoDetail: FC<TLearnerExamInfoDetailProps> = ({ data }) => {
  const { data: japaneseLevelTypeOptions } = useEnum("EJapaneseLevelType");

  return (
    <InnerBox
      title={<Typography variant="head20Bold">分野・日本語能力・試験記録</Typography>}
      showDivider={false}
    >
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <ItemInfo label="受験分野" value={data?.industry?.name} required />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="日本語能力" value={findLabelByValue(japaneseLevelTypeOptions, data?.japaneseLanguageLevel)} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo
            label="前回試験の受験日"
            value={isDayjs(data?.lastExamDate) ? data.lastExamDate.format(DATE_FORMAT) : data?.lastExamDate}
          />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo
            label="前回試験の点数"
            value={data?.lastExamScore?.toString()}
          />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
